// @ts-strict-ignore
import { FriendInfoVO } from '@project/components/permissions/friend-info.vo';
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';

@JsonObject('FriendListEntryVO')
export class FriendListEntryVO {
  @JsonProperty('id', 'Number')
  public id: number = undefined;

  @JsonProperty('userId', 'Number')
  public userId: number = undefined;

  @JsonProperty('friendInfo', 'FriendInfoVO')
  public friendInfo: FriendInfoVO = undefined;

  @JsonProperty('creationDate', 'DateConverter', true)
  public creationDate: Date = undefined;
}
